export { default } from './read-more-link';
